import React, { useState } from 'react';
import { Box, Typography, Link } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { styled, keyframes } from '@mui/material/styles';

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
  }
  70% {
    box-shadow: 0 0 0 20px rgba(37, 211, 102, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
  }
`;

const FloatingContainer = styled(Box)(({ theme }) => ({
    position: 'fixed',
    bottom: 30,
    right: 30,
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row-reverse', // Label to the left of button
    cursor: 'pointer',
}));

const ActionButton = styled(Box)(({ theme, isHovered }) => ({
    width: 60,
    height: 60,
    borderRadius: '50%',
    backgroundColor: '#25D366',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
    transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
    zIndex: 3,
    animation: `${pulse} 2s infinite`,
    transform: isHovered ? 'scale(1.1) rotate(15deg)' : 'scale(1)',
    '&:hover': {
        boxShadow: '0 8px 25px rgba(37, 211, 102, 0.4)',
    },
}));

const LabelContainer = styled(Box)(({ theme, show }) => ({
    backgroundColor: theme.palette.mode === 'light' ? 'rgba(255, 255, 255, 0.98)' : 'rgba(30, 41, 59, 0.98)',
    color: theme.palette.mode === 'light' ? '#111827' : '#f8fafc',
    padding: '10px 20px',
    borderRadius: '25px',
    marginRight: 10,
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.15)',
    opacity: show ? 1 : 0,
    transform: `translateX(${show ? '0' : '30px'}) scale(${show ? 1 : 0.8})`,
    transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
    visibility: show ? 'visible' : 'hidden',
    whiteSpace: 'nowrap',
    zIndex: 2,
    backdropFilter: 'blur(10px)',
    border: `1px solid ${theme.palette.mode === 'light' ? 'rgba(0,0,0,0.08)' : 'rgba(255,255,255,0.08)'}`,
}));

function WhatsAppButton() {
    const [hovered, setHovered] = useState(false);
    const phoneNumber = "923007370282";
    const message = "Hello, I would like to book a consultant.";

    return (
        <FloatingContainer
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <Link
                href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ textDecoration: 'none', display: 'flex', alignItems: 'center', flexDirection: 'row-reverse' }}
            >
                <ActionButton isHovered={hovered}>
                    <WhatsAppIcon sx={{ fontSize: 34 }} />
                </ActionButton>

                <LabelContainer show={hovered}>
                    <Typography variant="body2" sx={{ fontWeight: 700, letterSpacing: '0.2px' }}>
                        Book a consultant
                    </Typography>
                </LabelContainer>
            </Link>
        </FloatingContainer>
    );
}

export default WhatsAppButton;
